export default __webpack_public_path__ + "static/media/7_text.b1aa1c35.png";